import React, { useContext } from "react";
import "./Add_on_zoom_modal.css";
import { Card, Modal } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import { Context } from "../../../../../utils/context";

function Add_on_zoom_modal({ show, onHide, addons = [], initialIndex = 0 }) {
  const totalSlides = addons.length;
 const { getData, IMG_URL } = useContext(Context);
  return (
    <div className="Successfull_Modal_sec">
      <Modal
        className="Successfull_Modal Add_on_zoom_modal"
        show={show}
        onHide={onHide}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add-Ons</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Swiper
            spaceBetween={10}
            watchOverflow={true}
            loop
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            navigation={true}
            modules={[Autoplay, Navigation]}
            initialSlide={initialIndex}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              576: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 1,
              },
              992: {
                slidesPerView: 1,
              },
              1200: {
                slidesPerView: 1,
              },
            }}
          >
            {addons?.addon_images?.map((item, index) => (
              <SwiperSlide key={index}>
                <Card>
                  <Card.Img
                    variant="top"
                    src={IMG_URL+item.image || "/assets/Image/near-me/phone.png"}
                  />
                  <Card.Body>
                    <Card.Title>{addons.name}</Card.Title>
                    <Card.Text>₹{addons.price}</Card.Text>
                  </Card.Body>
                </Card>
              </SwiperSlide>
            ))}
          </Swiper>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Add_on_zoom_modal;
